var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValueErrorOperationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7502 19.4998H2.2498C1.42281 19.4998 0.75 18.827 0.75 18V1.9998C0.75 1.17281 1.42281 0.5 2.2498 0.5H11.7502C12.5772 0.5 13.25 1.17281 13.25 1.9998V7.50025C11.8842 7.51503 10.7777 8.63068 10.7777 9.9999C10.7777 10.7841 11.148 11.5095 11.7472 11.9753C11.5894 12.2152 11.5004 12.5003 11.5004 12.7998V16.8003C11.5004 17.6273 12.1733 18.3002 13.0003 18.3002H13.2198C13.0804 18.9838 12.4744 19.4998 11.7502 19.4998Z",
    fill: "#272D55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7502 18.9998C12.0185 18.9998 12.2624 18.8936 12.4422 18.721C11.6102 18.4788 11.0004 17.7094 11.0004 16.8003V12.7998C11.0004 12.5532 11.0456 12.3139 11.1298 12.0917C10.596 11.5424 10.2777 10.7964 10.2777 9.9999C10.2777 8.52571 11.3465 7.29649 12.75 7.04653V1.9998C12.75 1.44851 12.3015 1 11.7502 1H2.2498C1.69851 1 1.25 1.44851 1.25 1.9998V18C1.25 18.5513 1.69851 18.9998 2.2498 18.9998H11.7502ZM11.7502 19.9998H2.2498C1.14711 19.9998 0.25 19.1027 0.25 18V1.9998C0.25 0.89711 1.14711 0 2.2498 0H11.7502C12.8529 0 13.75 0.89711 13.75 1.9998V8.0559C13.5987 8.0192 13.4401 8.0001 13.2775 8.0001C12.1748 8.0001 11.2777 8.89721 11.2777 9.9999C11.2777 10.8407 11.81 11.5972 12.6023 11.8823C12.2367 12.0412 12.0004 12.4006 12.0004 12.7998V16.8003C12.0004 17.3517 12.4489 17.8002 13.0003 17.8002H13.75V18C13.75 19.1027 12.8529 19.9998 11.7502 19.9998Z",
    fill: "#272D55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 3.5H9.75",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 6.5H8.75",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 9.5H6.75",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7227 13.125V16.388",
    stroke: "#272D55",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7223 11.3607C14.474 11.3607 15.0833 10.7513 15.0833 9.99967C15.0833 9.24801 14.474 8.63867 13.7223 8.63867C12.9707 8.63867 12.3613 9.24801 12.3613 9.99967C12.3613 10.7513 12.9707 11.3607 13.7223 11.3607Z",
    fill: "#272D55"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7223 10.8607C14.1978 10.8607 14.5833 10.4752 14.5833 9.99967C14.5833 9.52415 14.1978 9.13867 13.7223 9.13867C13.2468 9.13867 12.8613 9.52415 12.8613 9.99967C12.8613 10.4752 13.2468 10.8607 13.7223 10.8607Z",
    stroke: "#272D55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValueErrorOperationIcon);
export default __webpack_public_path__ + "static/media/ValueErrorOperationIcon.8d5fcdcc33890ea4ec4ee159b7236598.svg";
export { ForwardRef as ReactComponent };